import styled, { css, keyframes } from "styled-components";
import { color } from "@m/alchemy-theme";
const fade = keyframes `
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
`;
export const Ellipsis = styled.div `
  display: ${({ inline }) => (inline ? "inline-block" : "block")};
  line-height: 0;
  white-space: nowrap;

  span:not(last-child) {
    display: inline-block;
    ${({ activeColorScheme, circleSize, inverted, speed, ...props }) => css `
      animation: ${fade} ${speed / 2}s infinite alternate;
      /* TODO fix forced colors mode */
      background-color: ${inverted
    ? activeColorScheme === "alchemyBrand"
        ? color("inverse")(props)
        : color("container")(props)
    : color("base")(props)};
      border-radius: ${circleSize / 2}px;
      height: ${circleSize}px;
      margin: 2px;
      transition: opacity ${speed}s linear;
      width: ${circleSize}px;
    `} &:nth-child(2) {
      animation-delay: 0.17s;
    }

    &:nth-child(3) {
      animation-delay: 0.34s;
    }
  }
`;
export const LoadingIndicator = styled.div `
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;

  > ${Ellipsis} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
